<template>
    <input ref="date" inputmode='none' class="form-control new-design date-icon" :placeholder="placeholder" :value="value"
           @change="handleChange">
</template>

<script>
export default {
    name: "Date",
    props: ['value', 'placeholder', 'dateFormat', 'name'],
    data() {
        return {
            input: null
        }
    },
    methods: {
        initiate() {
            this.input = $(this.$refs['date']).datepicker({
                todayBtn: "linked",
                todayHighlight: true,
                keyboardNavigation: false,
                forceParse: false,
                calendarWeeks: true,
                autoclose: true,
                format: this.dateFormat
            })

            this.input.on('changeDate', (event) => {
                this.$emit('input', event.format())
            })
        },
        handleChange(event) {
            this.$emit('input', event.target.value)
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.initiate();
        })
    }
}
</script>

<style scoped>
.form-control.new-design::placeholder {
    font-family: 'Roboto', serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
}

.form-control.new-design {
    padding: 16px;
    border: 1px solid #E0E2E5;
    border-radius: 8px;
    box-sizing: border-box;

    height: 56px;

    font-family: 'Roboto', serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
}

.date-icon {
    background-repeat: no-repeat;
    background-position: 15px 17px;
    padding-left: 45px !important;
    background-image: url("data:image/svg+xml,%3Csvg width='18' height='20' viewBox='0 0 18 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M16 2H15V0H13V2H5V0H3V2H2C0.89 2 0.00999999 2.9 0.00999999 4L0 18C0 19.1 0.89 20 2 20H16C17.1 20 18 19.1 18 18V4C18 2.9 17.1 2 16 2ZM16 18H2V8H16V18ZM16 6H2V4H16V6ZM6 12H4V10H6V12ZM10 12H8V10H10V12ZM14 12H12V10H14V12ZM6 16H4V14H6V16ZM10 16H8V14H10V16ZM14 16H12V14H14V16Z' fill='%232E4051'/%3E%3C/svg%3E%0A");
}
</style>    